import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { connectState, InputObservable } from '@examdojo/angular/util';
import { IconComponent } from '@examdojo/core/icon';
import { UntilDestroy } from '@ngneat/until-destroy';
import { map, Observable } from 'rxjs';
import { TopicStatus, TopicStatusToUI } from '../model';

@UntilDestroy()
@Component({
  selector: 'dojo-topic-status-icon',
  template: `
    @if (state.icon) {
      <dojo-icon
        [size]="size"
        [icon]="state.icon"
        [renderSvgAsImg]="true"
        [alt]="state.label"
        [matTooltip]="tooltip ?? state.label ?? ''"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, MatTooltipModule],
  host: {
    class: 'inline-flex',
  },
})
export class TopicStatusIconComponent {
  @Input({ required: true })
  @InputObservable()
  status!: TopicStatus;
  private readonly status$!: Observable<TopicStatus | undefined>;

  @Input() size: string | number = 16;

  @Input() tooltip?: string;

  readonly assetStatusUI$ = this.status$.pipe(map((status) => status && TopicStatusToUI[status]));

  readonly state = connectState({
    status: this.status$,
    label: this.assetStatusUI$.pipe(map((ui) => ui?.label)),
    icon: this.assetStatusUI$.pipe(map((ui) => ui?.logo)),
  });
}
